module.exports = __webpack_public_path__ + "img/micro-school-crm.9cd1d164.jpg";